import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _openBlock(), _createElementBlock("div", {
        class: "pe-frame-container",
        style: _normalizeStyle(_ctx.style)
    }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 4);
}
